import { Link } from "react-router-dom";
import { Database, UploadCloud } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

export function EmptyState({ title, description, cta = true, icon: Icon = Database, testid = "empty-state" }) {
  return (
    <Card data-testid={testid} className="empty-card">
      <CardContent className="empty-content">
        <div className="empty-icon"><Icon className="h-7 w-7" /></div>
        <div>
          <h3>{title}</h3>
          <p>{description}</p>
        </div>
        {cta && (
          <Button asChild data-testid="empty-state-import-button" className="rounded-xl">
            <Link to="/importar"><UploadCloud className="h-4 w-4" /> Importar manos</Link>
          </Button>
        )}
      </CardContent>
    </Card>
  );
}
